<template>
    <div class="container p-4 md:p-8">
        <div class="tabs is-centered mb-8">
            <ul>
                <li :class="isDescriptionActive ? 'is-active' : ''">
                    <a
                        id="tab-description"
                        @click="clickTab"
                        :class="isDescriptionActive"
                        >Description</a
                    >
                </li>
                <li :class="isFactActive ? 'is-active' : ''" v-if="hasFact">
                    <a id="tab-fact" @click="clickTab">Facts &amp; Figures</a>
                </li>
                <li
                    :class="isInteriorActive ? 'is-active' : ''"
                    v-if="hasInterior"
                >
                    <a id="tab-interior" @click="clickTab">Interior</a>
                </li>
                <li
                    :class="isPropertyActive ? 'is-active' : ''"
                    v-if="hasProperty"
                >
                    <a id="tab-property" @click="clickTab">Property</a>
                </li>
                <li
                    :class="isFinancialActive ? 'is-active' : ''"
                    v-if="hasFinancial"
                >
                    <a id="tab-financial" @click="clickTab">Financial</a>
                </li>
                <li
                    :class="isUtilityActive ? 'is-active' : ''"
                    v-if="hasUtility"
                >
                    <a id="tab-utility" @click="clickTab">Utility</a>
                </li>
                <li
                    :class="isCommunityActive ? 'is-active' : ''"
                    v-if="hasCommunity"
                >
                    <a id="tab-community" @click="clickTab">Community</a>
                </li>
            </ul>
        </div>
        <div class="tab-contents">
            <description-tab
                :description="description"
                v-show="isDescriptionActive"
            ></description-tab>
            <div id="fact" class="tab-content container" v-if="isFactActive">
                <profile-table :data="getFactHighlights"></profile-table>
            </div>
            <div
                id="interior"
                class="tab-content container"
                v-if="isInteriorActive"
            >
                <profile-table :data="getInteriorHighlights"></profile-table>
            </div>
            <div
                id="property"
                class="tab-content container"
                v-if="isPropertyActive"
            >
                <profile-table :data="getPropertyHighlights"></profile-table>
            </div>
            <div
                id="financial"
                class="tab-content container"
                v-if="isFinancialActive"
            >
                <profile-table :data="getFinancialHighlights"></profile-table>
            </div>
            <div
                id="utility"
                class="tab-content container"
                v-if="isUtilityActive"
            >
                <profile-table :data="getUtilityHighlights"></profile-table>
            </div>
            <div
                id="community"
                class="tab-content container"
                v-if="isCommunityActive"
            >
                <profile-table :data="getCommunityHighlights"></profile-table>
            </div>
        </div>
    </div>
</template>
<script>
import DescriptionTab from "./DescriptionTabContent.vue";
import ProfileTable from "./ProfileTable.vue";
export default {
    props: ["highlights", "description"],
    components: { DescriptionTab, ProfileTable },
    methods: {
        clickTab(e) {
            this.currentTab = e.target.id.substring(4);
        },
        hasDataType(type) {
            var results = this.$props["highlights"].filter(
                highlight => highlight.data_type == type
            );
            return results.length > 0;
        }
    },
    mounted() {},
    computed: {
        getDescriptionHighlights() {
            return this.highlights.filter(
                word => word.data_type == "description"
            );
        },
        getFactHighlights() {
            return this.highlights.filter(word => word.data_type == "fact");
        },
        getInteriorHighlights() {
            return this.highlights.filter(word => word.data_type == "interior");
        },
        getPropertyHighlights() {
            return this.highlights.filter(word => word.data_type == "property");
        },
        getFinancialHighlights() {
            return this.highlights.filter(
                word => word.data_type == "financial"
            );
        },
        getUtilityHighlights() {
            return this.highlights.filter(word => word.data_type == "utility");
        },
        getCommunityHighlights() {
            return this.highlights.filter(
                word => word.data_type == "community"
            );
        },
        isDescriptionActive() {
            return this.currentTab == "description";
        },
        isFactActive() {
            return this.currentTab == "fact";
        },
        isInteriorActive() {
            return this.currentTab == "interior";
        },
        isPropertyActive() {
            return this.currentTab == "property";
        },
        isFinancialActive() {
            return this.currentTab == "financial";
        },
        isUtilityActive() {
            return this.currentTab == "utility";
        },
        isCommunityActive() {
            return this.currentTab == "community";
        },
        hasFact() {
            return this.hasDataType("fact");
        },
        hasProperty() {
            return this.hasDataType("property");
        },
        hasFinancial() {
            return this.hasDataType("financial");
        },
        hasInterior() {
            return this.hasDataType("interior");
        },
        hasUtility() {
            return this.hasDataType("utility");
        },
        hasCommunity() {
            return this.hasDataType("community");
        }
    },
    data() {
        return {
            currentTab: "description"
        };
    }
};
</script>
